import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

export interface TbMonogramProps {
  className?: string;
  /** Extra inline styles merged with the mask style (e.g. explicit size). */
  style?: CSSProperties;
}

/**
 * The official monogram (canon §20): one file, viewBox 654.87 × 592.36, the same file every
 * design draws (`assets/tb_monogram.svg`).
 */
const MASK = "url('/images/brand/tb-monogram.svg')";

/**
 * TB monogram — the crest of the loaders, the photo placeholders and the footer watermark.
 *
 * Same masking approach as `TbWordmark` (see the note there on why the asset
 * lives in `public/`), so colour and opacity are the caller's decision. The mark is not square:
 * in the default square box it is centred and never stretched ("o monograma não é quadrado",
 * canon §20); a caller that wants the mark's own box passes `aspect-[654.87/592.36]`. Purely
 * decorative, hence `aria-hidden` and no label.
 */
export function TbMonogram({ className, style }: TbMonogramProps) {
  return (
    <span
      aria-hidden="true"
      className={cn("block aspect-square bg-current", className)}
      style={{
        WebkitMaskImage: MASK,
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        WebkitMaskSize: "contain",
        maskImage: MASK,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        ...style,
      }}
    />
  );
}
